import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function currency(price: number | null | undefined, options?: Intl.NumberFormatOptions) {
    if (price === undefined || price === null) {
        return <span>–</span>;
    } else {
        const formatted = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            useGrouping: true,
            ...options,
        }).format(price / 100);
        return <span className="tabular-nums">{formatted}</span>;
    }
}

export function formatPhoneNumber(phoneNumberString: string): string {
    const match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return phoneNumberString;
}
